/* global axios */
// Unified contract API client.
// Always calls /api/v1/contrato/:id[/sub] — Rails picks the backend
// (SUPRA REST or CEA SOAP) via the CONTRATO_URL env var. Zero frontend
// rebuild needed when switching backends.

const BASE = '/api/v1/contrato';

export const searchContratos = q =>
  axios.get(`${BASE}/search`, { params: { q } });

export const getContratoDetail = id =>
  axios.get(`${BASE}/${encodeURIComponent(id)}`);

export const getContratoConsumos = (id, explotacion) =>
  axios.get(`${BASE}/${encodeURIComponent(id)}/consumos`, {
    params: explotacion ? { explotacion } : {},
  });

export const getContratoLecturas = (id, explotacion) =>
  axios.get(`${BASE}/${encodeURIComponent(id)}/lecturas`, {
    params: explotacion ? { explotacion } : {},
  });

export const getContratoFinanciero = (id, explotacion) =>
  axios.get(`${BASE}/${encodeURIComponent(id)}/financiero`, {
    params: explotacion ? { explotacion } : {},
  });

export const getContratoRecibos = (id, explotacion) =>
  axios.get(`${BASE}/${encodeURIComponent(id)}/recibos`, {
    params: explotacion ? { explotacion } : {},
  });

export const getContratoTarifas = (id, explotacion) =>
  axios.get(`${BASE}/${encodeURIComponent(id)}/tarifas`, {
    params: explotacion ? { explotacion } : {},
  });
